export default "__VITE_ASSET__B3vHbbo5__"